import { render, staticRenderFns } from "./PreloaderMini.vue?vue&type=template&id=64961ff4&scoped=true&"
import script from "./PreloaderMini.vue?vue&type=script&lang=js&"
export * from "./PreloaderMini.vue?vue&type=script&lang=js&"
import style0 from "./PreloaderMini.vue?vue&type=style&index=0&id=64961ff4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64961ff4",
  null
  
)

export default component.exports